<!-- Filter Datatables -->
<section id="ngx-datatable-filter">
	<div class="row">
	  <div class="col-12"></div>
	  <div class="col-12">
		<div class="card">
		  <div class="card-content">
			<div class="card-body">
			  <!-- ngx-datatable-filter -->
			  <fieldset class="form-group">
				<div class="row align-items-end mt-0 pagination-body">
				  <div class="d-flex col-12 col-sm-12 col-md-6 col-lg-6 mb-2">
					<div class="row-flex">
						<div class="col-flex-2 mb-1 position-relative">
							<button type="reset" class="btn btn-primary btn-block users-list-clear glow mb-0"
						  	(click)="openModalNew(addNewMultiple)">
							  Add Bulk Attendance
						</button>
						</div>
					</div>
				  </div>
				  
				  <div class="col-12 col-sm-12 col-md-6 col-lg-6 mt-2 mb-1">
					<div class="row-flex">
					  <div class="col-flex-2 mb-1 position-relative">
						<input id="ngx-filter-ref"
						  class="form-control form-control-sm d-inline-block width-300 ml-1 rounded-right shadow searchInput"
						  type="text" placeholder="Search" #name (keydown.enter)="filterAttendence(searchVal)"
						  [(ngModel)]="searchVal" />
						<button class="btn search-btn glow position-absolute" (click)="filterAttendence(searchVal)">
						  <i class="ft-search text-white cursor-pointer"></i>
						</button>
					  </div>
					  <div class="col-flex-2 mb-1">
						<button class="btn btn-primary btn-block users-list-clear glow mb-0" (click)="resetFilter()">
						  Reset
						  <i class="ft-filter text-white cursor-pointer"></i>
						</button>
					  </div>
					  <div class="col-flex-2 mb-1"
						*ngIf=" user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
						<button type="reset" class="btn btn-primary btn-block users-list-clear glow mb-0"
						  (click)="openModalAddNew(addNew,'','addnew')" placement="top" ngbTooltip="Add New">
						  +
						</button>
					  </div>
					</div>
				  </div>
				</div>
					<div class="d-flex  col-12 col-sm-12 col-md-6 col-lg-6 mt-2 mb-1 date-filter">
						<div class="verified-box">
							<label>Filter</label>
							<ng-select #filterSelect
							[items]="filter_list"
							bindLabel="name"
							bindValue="_id"
							[closeOnSelect]="false"
							placeholder="Select Filter"
							[(ngModel)]="selected_filter"
							[ngModelOptions]="{ standalone: true }"
							(change)="getFilterId($event)"
							>
							</ng-select>
						</div>
						<div>
							<label>From Date</label>
							<input type="date" [(ngModel)]="start_date" class="form-control" (change)="getStartDate($event)">
						</div>
						<div *ngIf="selected_filter !='single'">
							<label>To Date</label>
							<input type="date" [(ngModel)]="end_date" class="form-control" (change)="getEndDate($event)">
						</div>
						<div class="verified-box">
							<label id="v-label">Verified Status</label>
							<ng-select
							[items]="verified_list"
							bindLabel="name"
							bindValue="_id"
							[closeOnSelect]="false"
							placeholder="Select status"
							[(ngModel)]="selected_verified_filter"
							[ngModelOptions]="{ standalone: true }"
							(change)="getFilterVerifiedId($event)"
							#mySelect>
							</ng-select>
						</div>
					  </div>
					  <div class="d-flex  col-12 col-sm-12 col-md-6 col-lg-6 mt-2 mb-1 date-filterrr">
						<div *ngFor="let item of status_count_data">
							<span  [ngClass]="{'badge bg-light-success':item?.status == 'full-day','badge bg-light-info':item?.status == 'half-day','badge bg-light-danger':item?.status == 'paid-leave','badge bg-light-warning':item?.status == 'unpaid-leave','badge bg-light-primary':item?.status == 'short-leave','badge bg-light-danger':item?.status == null}"><span *ngIf="item?.status">{{item?.status | titlecase}}</span> <span *ngIf="item?.status == null">Absent</span> </span> &nbsp; : <span class="mr-1"> {{item?.count}}</span>
						</div>
					  </div>
					  <div class="col">
						<button *ngIf="guideline_data" class="btn btn-outline-primary" (click)="openDynamicModal(guideline_data)">Attendence Guideline</button>
					  </div>
			  </fieldset>
			<!---- Listing Attendence ------------- -->
			  <ngx-datatable *ngIf="!isAttend_search" class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="50"
			  [footerHeight]="50" rowHeight="auto" [limit]="limitRef" [rows]="combinedArray"[scrollbarH]="true"
			  [columns]="columns" [externalPaging]="true" [count]="combinedArray?.length" [offset]="page.offset"
			  (page)="pageChangeData($event)">
			  <ngx-datatable-column name="Name" prop="user" [width]="30">
				<ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
					<p class="font-medium-1 line-height-1 mb-0">
						{{row?.user?.name}}
					</p>
					
				</ng-template>
			</ngx-datatable-column>
			  <ngx-datatable-column name="Attendance Date" prop="attendanceDate" [width]="30">
				<ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
				  <div class="d-flex align-items-center">
					<div class="cell-line-height cursor-pointer" >
					  <p *ngIf="row?.attendanceDate" class="font-medium-1 line-height-1 mb-0">
						  {{ mediumDate(row?.attendanceDate)  }}
					  </p>
					</div>
				  </div>
				</ng-template>
			  </ngx-datatable-column>
			  
			  <ngx-datatable-column name="Start Time" prop="startTime" [width]="10">
				  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
					<div *ngIf="row?.startTime" class="cell-line-height">
					 {{row?.startTime | convertTo12Hour }}
					</div>
					<div *ngIf="!row?.startTime" class="cell-line-height">
						-
					</div>
				  </ng-template>
				</ngx-datatable-column>
				<ngx-datatable-column name="End Time" prop="endTime" [width]="10">
				  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
					<div *ngIf="row?.endTime" class="cell-line-height">
					 {{row?.endTime | convertTo12Hour }}
					</div>
					<div *ngIf="!row?.endTime" class="cell-line-height">
						-
					</div>
				  </ng-template>
				</ngx-datatable-column>
			  <ngx-datatable-column name="Working Hours" prop="workingHours" [width]="10">
				<ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
				  <div *ngIf="row?.workingHours" class="cell-line-height">
				   {{row?.workingHours}}
				  </div>
				  <div *ngIf="!row?.workingHours" class="cell-line-height">
					-
				   </div>
				</ng-template>
			  </ngx-datatable-column>
			  
			  <ngx-datatable-column name="Task" prop="task" [width]="80">
				  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
					<div *ngIf="row?.task" class="cell-line-height">
					  <p [innerText]="row?.task"></p>
					</div>
					<div *ngIf="!row?.task" class="cell-line-height">
						-
					</div>
				  </ng-template>
				</ngx-datatable-column>
				<ngx-datatable-column name="Status" prop="name" [width]="10">
					<ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
						<p *ngIf="row?.status?.displayname == 'Full-Day'" [ngClass]="{'badge badge-pill bg-light-success':row?.status?.displayname == 'Full-Day'}">{{row?.status?.displayname}}</p>

						<p *ngIf="row?.status?.displayname == 'Paid Leave'" [ngClass]="{'badge badge-pill bg-light-danger':row?.status?.displayname == 'Paid Leave'}">{{row?.status?.displayname}}</p>
   
						<p *ngIf="row?.status?.displayname == 'Unpaid Leave'" [ngClass]="{'badge-pill bg-light-warning':row?.status?.displayname == 'Unpaid Leave'}">{{row?.status?.displayname}}</p>
   
						<p *ngIf="row?.status?.displayname == 'Half-Day'" [ngClass]="{'badge-pill bg-light-info':row?.status?.displayname == 'Half-Day'}">{{row?.status?.displayname}}</p>
						
						<p *ngIf="row?.status?.displayname == 'Short-Leave'" [ngClass]="{'badge-pill bg-light-primary':row?.status?.displayname == 'Short-Leave'}">{{row?.status?.displayname}}</p>
						<p *ngIf="!row?.status?.displayname">-</p>
					</ng-template>
				</ngx-datatable-column>
			  <ngx-datatable-column name="Verified" prop="isVerified" [width]="10">
				  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
					<p [matMenuTriggerFor]="verified_status">
						<span *ngIf="row?.isVerified == 'yes'"
                        [ngClass]="{'bg-light-success badge badge-pill':row?.isVerified == 'yes'}">
                        {{row?.isVerified}}
                      </span>
                      <span *ngIf="row?.isVerified == 'inreview'"
                        [ngClass]="{'bg-light-warning badge badge-pill':row?.isVerified == 'inreview'}">
                        in review
                      </span>
                      <span *ngIf="row?.isVerified == 'no'"
                        [ngClass]="{'bg-light-danger badge badge-pill':row?.isVerified == 'no'}">
                        {{row?.isVerified}}
                      </span>
					  <span *ngIf="!row?.isVerified">
						-
					  </span>
					</p>
					<mat-menu #verified_status="matMenu">
						<div *ngFor="let status of verified_list | slice : 0:3">
							<button mat-menu-item *ngIf="status?._id !== row?.isVerified"
							  (click)="updateVerifyStatus(row._id,status._id)">
							  <span>
								<span [ngClass]="{'bg-light-success badge badge-pill':status.name == 'Yes'}"
								  placement="top" *ngIf="status.name == 'Yes'">{{status.name}}</span>
								<span [ngClass]="{'bg-light-warning badge badge-pill':status.name == 'In-review'}"
								  placement="top" *ngIf="status.name == 'In-review'">{{status.name}}</span>
								<span [ngClass]="{'bg-light-danger badge badge-pill':status.name == 'No'}"
								  placement="top"
								  *ngIf="status.name == 'No'">{{status.name}}</span>
							  </span>
							</button>
						  </div>
					</mat-menu>
				  </ng-template>
				</ngx-datatable-column>
				<ngx-datatable-column name="Action" [width]="10">
					<ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
						<i class="ft-edit text primary cursor-pointer" *ngIf="row?.startTime && row?.endTime" (click)="openModalAddNew(addNew,row?._id,'edit')"></i>
						<i class="ft-plus text primary cursor-pointer" *ngIf="!row?.startTime && !row?.endTime" (click)="openModalAddNew(addNew,row?.user?._id,'rowuseradd')"></i>
						<i class="ft-trash text danger cursor-pointer ml-2" *ngIf="row?.startTime && row?.endTime" (click)="confirmDelete(row?._id)"></i>
					</ng-template>
				</ngx-datatable-column>
			  
			</ngx-datatable>
			<!---- Filter Attendence ------------- -->
			<ngx-datatable *ngIf="isAttend_search" class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="50"
			[footerHeight]="50" rowHeight="auto" [limit]="limitRef" [rows]="combinedArray"[scrollbarH]="true"
			[columns]="columns" [externalPaging]="true" [count]="combinedArray?.length" [offset]="page.offset"
			(page)="pageChangeData($event)">
			<ngx-datatable-column name="Name" prop="user" [width]="30">
			  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
				  <p class="font-medium-1 line-height-1 mb-0">
					  {{row?.user?.name}}
				  </p>
				  
			  </ng-template>
		  </ngx-datatable-column>
			<ngx-datatable-column name="Attendance Date" prop="attendanceDate" [width]="30">
			  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
				<div class="d-flex align-items-center">
				  <div class="cell-line-height cursor-pointer" >
					<p *ngIf="row?.attendance?.attendanceDate" class="font-medium-1 line-height-1 mb-0">
						{{ mediumDate(row?.attendance?.attendanceDate)  }}
					</p>
				  </div>
				</div>
			  </ng-template>
			</ngx-datatable-column>
			
			<ngx-datatable-column name="Start Time" prop="startTime" [width]="10">
				<ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
				  <div *ngIf="row?.attendance?.startTime" class="cell-line-height">
				   {{row?.attendance?.startTime | convertTo12Hour }}
				  </div>
				  <div *ngIf="!row?.attendance?.startTime" class="cell-line-height">
					  -
				  </div>
				</ng-template>
			  </ngx-datatable-column>
			  <ngx-datatable-column name="End Time" prop="endTime" [width]="10">
				<ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
				  <div *ngIf="row?.attendance?.endTime" class="cell-line-height">
				   {{row?.attendance?.endTime | convertTo12Hour }}
				  </div>
				  <div *ngIf="!row?.attendance?.endTime" class="cell-line-height">
					  -
				  </div>
				</ng-template>
			  </ngx-datatable-column>
			<ngx-datatable-column name="Working Hours" prop="workingHours" [width]="10">
			  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
				<div *ngIf="row?.attendance?.workingHours" class="cell-line-height">
				 {{row?.attendance?.workingHours}}
				</div>
				<div *ngIf="!row?.attendance?.workingHours" class="cell-line-height">
				  -
				 </div>
			  </ng-template>
			</ngx-datatable-column>
			
			<ngx-datatable-column name="Task" prop="task" [width]="80">
				<ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
				  <div *ngIf="row?.attendance?.task" class="cell-line-height">
					<p [innerText]="row?.attendance?.task"></p>
				  </div>
				  <div *ngIf="!row?.attendance?.task" class="cell-line-height">
					  -
				  </div>
				</ng-template>
			  </ngx-datatable-column>
			  <ngx-datatable-column name="Status" prop="name" [width]="10">
				  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
					  <p *ngIf="row?.attendance?.status?.displayname == 'Full-Day'" [ngClass]="{'badge badge-pill bg-light-success':row?.attendance?.status?.displayname == 'Full-Day'}">{{row?.attendance?.status?.displayname}}</p>

					  <p *ngIf="row?.attendance?.status?.displayname == 'Paid Leave'" [ngClass]="{'badge badge-pill bg-light-danger':row?.attendance?.status?.displayname == 'Paid Leave'}">{{row?.attendance?.status?.displayname}}</p>
 
					  <p *ngIf="row?.attendance?.status?.displayname == 'Unpaid Leave'" [ngClass]="{'badge-pill bg-light-warning':row?.attendance?.status?.displayname == 'Unpaid Leave'}">{{row?.attendance?.status?.displayname}}</p>
 
					  <p *ngIf="row?.attendance?.status?.displayname == 'Half-Day'" [ngClass]="{'badge-pill bg-light-info':row?.attendance?.status?.displayname == 'Half-Day'}">{{row?.attendance?.status?.displayname}}</p>
					  
					  <p *ngIf="row?.attendance?.status?.displayname == 'Short-Leave'" [ngClass]="{'badge-pill bg-light-primary':row?.attendance?.status?.displayname == 'Short-Leave'}">{{row?.attendance?.status?.displayname}}</p>
					  <p *ngIf="!row?.attendance?.status?.displayname">-</p>
				  </ng-template>
			  </ngx-datatable-column>
			<ngx-datatable-column name="Verified" prop="isVerified" [width]="10">
				<ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
				  <p [matMenuTriggerFor]="verified_status">
					  <span *ngIf="row?.attendance?.isVerified == 'yes'"
					  [ngClass]="{'bg-light-success badge badge-pill':row?.attendance?.isVerified == 'yes'}">
					  {{row?.attendance?.isVerified}}
					</span>
					<span *ngIf="row?.attendance?.isVerified == 'inreview'"
					  [ngClass]="{'bg-light-warning badge badge-pill':row?.attendance?.isVerified == 'inreview'}">
					  in review
					</span>
					<span *ngIf="row?.attendance?.isVerified == 'no'"
					  [ngClass]="{'bg-light-danger badge badge-pill':row?.attendance?.isVerified == 'no'}">
					  {{row?.attendance?.isVerified}}
					</span>
					<span *ngIf="!row?.attendance?.isVerified">
					  -
					</span>
				  </p>
				  <mat-menu #verified_status="matMenu">
					  <div *ngFor="let status of verified_list | slice : 0:3">
						  <button mat-menu-item *ngIf="status?._id !== row?.attendance?.isVerified"
							(click)="updateVerifyStatus(row?.attendance?._id,status._id)">
							<span>
							  <span [ngClass]="{'bg-light-success badge badge-pill':status.name == 'Yes'}"
								placement="top" *ngIf="status.name == 'Yes'">{{status.name}}</span>
							  <span [ngClass]="{'bg-light-warning badge badge-pill':status.name == 'In-review'}"
								placement="top" *ngIf="status.name == 'In-review'">{{status.name}}</span>
							  <span [ngClass]="{'bg-light-danger badge badge-pill':status.name == 'No'}"
								placement="top"
								*ngIf="status.name == 'No'">{{status.name}}</span>
							</span>
						  </button>
						</div>
				  </mat-menu>
				</ng-template>
			  </ngx-datatable-column>
			  <ngx-datatable-column name="Action" [width]="10">
				  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
					  <i class="ft-edit text primary cursor-pointer" *ngIf="row?.attendance?.startTime && row?.attendance?.endTime" (click)="openModalAddNew(addNew,row?.attendance?._id,'edit')"></i>
					  <i class="ft-plus text primary cursor-pointer" *ngIf="!row?.attendance?.startTime && !row?.endTime" (click)="openModalAddNew(addNew,row?.attendance?._id,'rowuseradd')"></i>
					  <i class="ft-trash text danger cursor-pointer ml-2" *ngIf="row?.attendance?.startTime && row?.attendance?.endTime" (click)="confirmDelete(row?.attendance?._id)"></i>
				  </ng-template>
			  </ngx-datatable-column>
			
		  </ngx-datatable>			 
			  <!-- ngx-datatable-filter -->
			</div>
		  </div>
		</div>
	  </div>
	</div>
  </section>
  <!--/ Filter Datatables -->
  <div class="d-flex justify-content-between align-items-center">
	<ngx-spinner></ngx-spinner>
  </div>

<!------  Add / Update Attendence Popup -------------------------->

<div>
	<ng-template #addNew let-modal>
	  <div class="modal-header">
		<h4 class="modal-title" *ngIf="!attendence_id">Add Attendence</h4>
		<h4 class="modal-title" *ngIf="attendence_id">Update Attendence</h4>
		<button type="button" class="close" (click)="modal.dismiss()">
		  <span>&times;</span>
		</button>
	  </div>
	  <div class="modal-body">
		<form [formGroup]="attendenceForm">
			<fieldset class="form-group">
				<label>User</label>
				<ng-select
				  [items]="emp_list"
				  bindLabel="name"
				  bindValue="_id"
				  [closeOnSelect]="false"
				  placeholder="Select user"
				  [(ngModel)]="selected_emp"
				  [ngModelOptions]="{ standalone: true }"
				  (change)="getEmpId($event)"
				>
				</ng-select>
			  </fieldset>
			<fieldset class="form-group">
				<label>Attendance Date</label>
				<input
				  type="date"
				  class="form-control"
				  formControlName="attendanceDate"
				  [ngModel]="model.attendanceDate | date: 'yyyy-MM-dd'"
				  [max]="maxDate"
				  [disabled]="false"
				  id="attendanceDate"
				  required
				/>
			</fieldset>
			<fieldset class="form-group">
			  <label>Start Time</label>
			  <input
				type="time"
				class="form-control"
				[formControl]="startTime" [(ngModel)]="model.startTime"
				id="startTime"
				placeholder="Enter start time"
				required
			  />
			
			</fieldset>
			<fieldset class="form-group">
				<label>End Time</label>
				<input
				  type="time"
				  class="form-control"
				  [formControl]="endTime" [(ngModel)]="model.endTime"  
				  id="endTime"
				  placeholder="Enter end time" 
				  required
				/>
			</fieldset>
			<fieldset class="form-group">
				<label>Working Hours</label>
				<input
				  type="text"
				  class="form-control"
				  [(ngModel)]="timeDiff" [ngModelOptions]="{standalone: true}"
				  placeholder="Enter Work Hours" readonly
				/>
			</fieldset>

			  <fieldset class="form-group">
				<label>Status</label>
				<ng-select
				  [items]="status_list"
				  bindLabel="displayname"
				  bindValue="_id"
				  [closeOnSelect]="false"
				  placeholder="Select status"
				  [(ngModel)]="selected_status"
				  [ngModelOptions]="{ standalone: true }"
				  (change)="getStatusId($event)"
				>
				</ng-select>
			  </fieldset>
			  <fieldset class="form-group">
				<label>Verified</label>
				<ng-select
				  [items]="verified_list"
				  bindLabel="name"
				  bindValue="_id"
				  [closeOnSelect]="false"
				  placeholder="Select status"
				  [(ngModel)]="selected_verified"
				  [ngModelOptions]="{ standalone: true }"
				  (change)="getVerifiedId($event)"
				>
				</ng-select>
			  </fieldset>
			
			  <fieldset class="form-group">
				<label>Task <span class="required_field mr-2">*</span> <span (click)="importTask()"  placement="right" ngbTooltip="Import current task"><i class="ft-arrow-down-circle text-primary font-large cursor-pointer"></i></span></label>
				<textarea
				  formControlName="task" [(ngModel)]="model.task"
				  id="tasktext"
				  rows="3"
				  class="form-control"
				  name="comment2"
				  placeholder="Enter task (at least 20 characters)"
				  required
				></textarea>
				  <div *ngIf="attendenceForm.get('task').hasError('notEnoughCharacters')" class="error-message">
					<small>Task must have at least 20 characters.</small>
				  </div>
			  </fieldset>
			<fieldset class="form-group">
			  <label>Notes to Hr</label>
			  <textarea
				formControlName="notes" [(ngModel)]="model.notes"
				id="hidden-label-form-6"
				rows="3"
				class="form-control"
				name="comment2"
				placeholder="Enter notes"
			  ></textarea>
			</fieldset>
			<fieldset class="form-group">
				<label>Admin Notes</label>
				<textarea
				  formControlName="admin_notes" [(ngModel)]="model.admin_notes"
				  id="hidden-label-form-6"
				  rows="3"
				  class="form-control"
				  name="comment2"
				  placeholder="Enter notes"
				></textarea>
			  </fieldset>
		  </form>
  
	  </div>
	  <div class="modal-footer">
		<button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
		<button [disabled]="!attendenceForm.get('task').valid" type="button" class="btn btn-primary" (click)="submit()">Submit</button>
	  </div>
	</ng-template>
  </div>

<!------ Add Attendence for All Employee -->

<div>
	<ng-template #addNewMultiple let-modal>
	  <div class="modal-header">
		<h4 class="modal-title">Add Bulk Attendence</h4>
		<button type="button" class="close" (click)="modal.dismiss()">
		  <span>&times;</span>
		</button>
	  </div>
	  <div class="modal-body">
		<!-- <fieldset class="form-group">
			<label>Select Days</label>
			<ng-select
			  [items]="days_list"
			  bindLabel="name"
			  bindValue="_id"
			  [closeOnSelect]="false"
			  placeholder="Select Day"
			  [(ngModel)]="selected_day"
			  [ngModelOptions]="{ standalone: true }"
			  (change)="getDayId($event)"
			>
			</ng-select>
		  </fieldset> -->
		  <fieldset class="form-group">
			<label>Attendance Date</label>
			<input
			  type="date"
			  class="form-control"
			  [ngModel]="select_attendanceDate | date: 'yyyy-MM-dd'"
			  [max]="maxDate"
			  id="attendanceDate"
			  (change)="selectedDateEmpAttendence($event)"
			/>
		</fieldset>
		  <fieldset class="form-group">
			<label>User</label>
			<ng-select
			  [items]="empFullPart_list"
			  bindLabel="userName"
			  bindValue="userId"
			  [multiple]="true"
			  [closeOnSelect]="false"
			  placeholder="Select user"
			  [(ngModel)]="selected_allEmp"
			  [ngModelOptions]="{ standalone: true }"
			  (change)="getEmpId($event)"
			>
			</ng-select>
		  </fieldset>
	  </div>
	  <div class="modal-footer">
		<button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
		<button type="button" class="btn btn-primary" (click)="submitAttend()">Submit</button>
	  </div>
	</ng-template>
</div>

